import { ChevronDown, Loader2 } from "lucide-react";

export default function CalculatorFlavorSelect({
  flavors,
  value,
  onChange,
  loading = false,
  emptyMessage = "No flavors available",
}) {
  if (loading) {
    return (
      <div className="driver-calc-select-empty">
        <Loader2 className="mr-2 h-4 w-4 animate-spin text-[#EE2677]" aria-hidden />
        Loading flavors…
      </div>
    );
  }

  if (!flavors?.length) {
    return <div className="driver-calc-select-empty">{emptyMessage}</div>;
  }

  return (
    <div className="driver-calc-select-wrap">
      <select
        className="driver-calc-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Select flavor"
      >
        {flavors.map((f) => (
          <option key={f.flavor} value={f.flavor}>
            {f.flavor}
          </option>
        ))}
      </select>
      <span className="driver-calc-select-chevron" aria-hidden>
        <ChevronDown size={22} strokeWidth={2.5} />
      </span>
    </div>
  );
}
